import { render, staticRenderFns } from "./WorkOrderProcessDetailUpload.vue?vue&type=template&id=4bc005d0&"
import script from "./WorkOrderProcessDetailUpload.vue?vue&type=script&lang=js&"
export * from "./WorkOrderProcessDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports